import DeliveryMethodDetails from "./DeliveryMethodDetails";

export { DeliveryMethodDetails };
export default DeliveryMethodDetails;
